import { render, staticRenderFns } from "./modifyApplyBlock.vue?vue&type=template&id=1588949f&"
import script from "./modifyApplyBlock.vue?vue&type=script&lang=js&"
export * from "./modifyApplyBlock.vue?vue&type=script&lang=js&"
import style0 from "./modifyApplyBlock.vue?vue&type=style&index=0&id=1588949f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports